import React from 'react'
import { Form, Col, DropdownButton, Dropdown } from 'react-bootstrap'

// definitions
import { StripeRule } from '../../../../../../back-end/utilities/apiDefinitions'
import { CustomMappingProps } from './CustomMapping'

interface CustomMappingRuleProps extends CustomMappingProps {
	stripeRule: StripeRule
	handleRuleUpdate: (stripeRuleID: string, values: Partial<StripeRule>) => void
}

const CustomMappingRule = (props: CustomMappingRuleProps) => {
	const selectedStripeObjectMap = props.stripeObjectMaps.find((option) => option.propertyName === props.stripeRule.key)
	const selectedStripeObjectMapSelectOption = props.stripeObjectMapSelectOptions.find((option) => option.value === props.stripeRule.valueVARCHAR) // selects are varchars
	const selectedStripeElementType = props.stripeMappingTypes.find((mappingType) => mappingType.stripeMappingTypeID === props.stripeRule.stripeMappingTypeID)
	const stripeObjectMapOptions = props.stripeObjectMaps.filter((option) => option.stripeMappingTypeID === props.stripeRule.stripeMappingTypeID)
	const stripeObjectSelectOptions = props.stripeObjectMapSelectOptions.filter(
		(option) => option.stripeObjectMapID === selectedStripeObjectMap?.stripeObjectMapID
	)

	return (
		<>
			<Col sm={3}>
				<DropdownButton
					id={`${props.customMapping.stripeOrgAccountXeroOrgMappingID}-stripe-mapping-type-select`}
					title={selectedStripeElementType?.name ?? 'Select...'}
					onSelect={(eventKey) => eventKey && props.handleRuleUpdate(props.stripeRule.stripeRuleID!, { stripeMappingTypeID: eventKey })}
				>
					{props.stripeMappingTypes.map((mappingType) => (
						<Dropdown.Item key={mappingType.stripeMappingTypeID} eventKey={mappingType.stripeMappingTypeID}>
							{mappingType.name}
						</Dropdown.Item>
					))}
				</DropdownButton>
			</Col>
			<Col sm={2}>
				{/* If we are controlling the user input, show options from database, else fall through to free text field (currently used for metadata) */}
				{stripeObjectMapOptions.length ? (
					<DropdownButton
						id={`${props.customMapping.stripeOrgAccountXeroOrgMappingID}-stripe-object-map-select`}
						title={selectedStripeObjectMap?.label ?? 'Select...'}
						onSelect={(eventKey) => {
							props.handleRuleUpdate(props.stripeRule.stripeRuleID!, {
								key: stripeObjectMapOptions.find((option) => option.stripeObjectMapID === eventKey)?.propertyName,
							})
						}}
					>
						{stripeObjectMapOptions.map((objectMap) => (
							<Dropdown.Item key={objectMap.stripeObjectMapID} eventKey={objectMap.stripeObjectMapID}>
								{objectMap.label}
							</Dropdown.Item>
						))}
					</DropdownButton>
				) : (
					<Form.Control
						value={props.stripeRule.key ?? ''}
						onChange={(e) => props.handleRuleUpdate(props.stripeRule.stripeRuleID!, { key: e.target.value })}
					/>
				)}
			</Col>
			<Col sm="auto" className="p-0 m-0 d-flex align-items-center">
				=
			</Col>
			<Col sm={3}>
				{selectedStripeObjectMap?.fieldType === 'Select' ? (
					<DropdownButton
						id={`${props.customMapping.stripeOrgAccountXeroOrgMappingID}-stripe-object-map-value-select`}
						title={selectedStripeObjectMapSelectOption?.label ?? 'Select...'}
						onSelect={(eventKey) => {
							console.log('eventKey', eventKey, stripeObjectSelectOptions)
							// For now, all underlying select values are still text
							props.handleRuleUpdate(props.stripeRule.stripeRuleID!, {
								valueVARCHAR: stripeObjectSelectOptions.find((option) => option.stripeObjectMapSelectOptionID === eventKey)?.value,
							})
						}}
					>
						{stripeObjectSelectOptions.map((valueOption) => (
							<Dropdown.Item key={valueOption.stripeObjectMapSelectOptionID} eventKey={valueOption.stripeObjectMapSelectOptionID}>
								{valueOption.label}
							</Dropdown.Item>
						))}
					</DropdownButton>
				) : selectedStripeObjectMap?.fieldType === 'Number' ? (
					<Form.Control
						type="number"
						value={props.stripeRule.valueINTEGER ?? ''}
						onChange={(e) => props.handleRuleUpdate(props.stripeRule.stripeRuleID!, { valueINTEGER: parseInt(e.target.value, 10) })}
					/>
				) : (
					<Form.Control
						value={props.stripeRule.valueVARCHAR ?? ''}
						onChange={(e) => props.handleRuleUpdate(props.stripeRule.stripeRuleID!, { valueVARCHAR: e.target.value })}
					/>
				)}
			</Col>
		</>
	)
}

export { CustomMappingRule }
